export const LOCAL_DATE_FORMAT = 'YYYY-MM-DDTHH:mm';

export const AUTO_ACTIVATED_VOUCHER_RESULT = Object.freeze({
  ACTIVATED: 'ACTIVATED',
  NOT_AUTOACTIVATED: 'NOT_AUTOACTIVATED',
  USER_HAS_ACTIVE_VOUCHER: 'USER_HAS_ACTIVE_VOUCHER',
  USER_NOT_EXISTS: 'USER_NOT_EXISTS',
})

export const BANNER_CLOSE_TYPE = Object.freeze({
  HIDE_UNTIL_NEXT_APP_START: 'HIDE_UNTIL_NEXT_APP_START',
  HIDE_UNTIL_TIMEFRAME: 'HIDE_UNTIL_TIMEFRAME',
  UNCLOSABLE: 'UNCLOSABLE',
})

export const BANNER_CLOSE_TYPE_OPTIONS = Object.freeze({
  [BANNER_CLOSE_TYPE.HIDE_UNTIL_NEXT_APP_START]: {
    label: 'Alkalmazás megnyitásakor újra látható'
  },
  // Allow it when the app will support it
  // [BANNER_CLOSE_TYPE.HIDE_UNTIL_TIMEFRAME]: {
  //   label: 'Adott idő után újra látható'
  // },
  [BANNER_CLOSE_TYPE.UNCLOSABLE]: {
    label: 'Nem bezárható'
  }
})


export const BANNER_LOCATION = Object.freeze({
  HOME_PAGE_ABOVE_CATEGORY_LIST: 'HOME_PAGE_ABOVE_CATEGORY_LIST',
})

export const BANNER_LOCATION_OPTIONS = Object.freeze({
  [BANNER_LOCATION.HOME_PAGE_ABOVE_CATEGORY_LIST]: {
    label: 'Nyitó képernyőn a könyv kategória lista fölött',
  }
})

export const BANNER_SUBSCRIPTION_RULE = Object.freeze({
  ANY: 'ANY',
  SUBSCRIBER: 'SUBSCRIBER',
  NON_SUBSCRIBER: 'NON_SUBSCRIBER',
})

export const BANNER_SUBSCRIPTION_RULE_OPTIONS = Object.freeze({
  [BANNER_SUBSCRIPTION_RULE.ANY]: {
    label: 'Mindenki',
  },
  [BANNER_SUBSCRIPTION_RULE.SUBSCRIBER]: {
    label: 'Csak előfizetők',
  },
  [BANNER_SUBSCRIPTION_RULE.NON_SUBSCRIBER]: {
    label: 'Csak nem előfizetők',
  },
})

export const CHAPTER_TYPES = Object.freeze({
  AUDIO: 'audio',
  EBOOK: 'e-book',
})

export const CHAPTER_GENERATE_AI_AUDIO_STATUS = Object.freeze({
  NOT_NEEDED: 'NOT_NEEDED',
  NEED_TO_GENERATE: 'NEED_TO_GENERATE',
  GENERATING: 'GENERATING',
  DONE: 'DONE',
  ERROR: 'ERROR',
})

export const CHAPTER_GENERATE_AI_AUDIO_STATUS_DROPDOWN_VALUES = Object.freeze([
  { value: CHAPTER_GENERATE_AI_AUDIO_STATUS.NOT_NEEDED, name: 'Nem szükséges' },
  { value: CHAPTER_GENERATE_AI_AUDIO_STATUS.NEED_TO_GENERATE, name: 'Generálás szükséges' },
  { value: CHAPTER_GENERATE_AI_AUDIO_STATUS.GENERATING, name: 'Generálás alatt' },
  { value: CHAPTER_GENERATE_AI_AUDIO_STATUS.DONE, name: 'Kész' },
  { value: CHAPTER_GENERATE_AI_AUDIO_STATUS.ERROR, name: 'Hibás' },
])


export const CREDIT_SUBSCRIPTION_ACCOUNTING_MODE = Object.freeze({
  FIX_PRICE: 'FIX_PRICE',
  FIX_PRICE_AFTER_CONSUMED_PERCENT: 'FIX_PRICE_AFTER_CONSUMED_PERCENT',
  INFINITE_CONSUMPTION: 'INFINITE_CONSUMPTION',
  PERCENT: 'PERCENT',
})

export const CREDIT_SUBSCRIPTION_ACCOUNTING_MODE_DROPDOWN_VALUES = Object.freeze([
  { value: CREDIT_SUBSCRIPTION_ACCOUNTING_MODE.PERCENT, name: '%-os elszámolás' },
  { value: CREDIT_SUBSCRIPTION_ACCOUNTING_MODE.FIX_PRICE, name: 'Fix áras elszámolás' },
])

export const MONTHLY_SUBSCRIPTION_ACCOUNTING_MODE_DROPDOWN_VALUES = Object.freeze([
  { value: CREDIT_SUBSCRIPTION_ACCOUNTING_MODE.FIX_PRICE_AFTER_CONSUMED_PERCENT, name: 'X %-hallgatás után fix összeg' },
  { value: CREDIT_SUBSCRIPTION_ACCOUNTING_MODE.INFINITE_CONSUMPTION, name: 'Korlátlan kifizetés, óradíj alapján' },
])

export const CREDIT_SUBSCRIPTION_INPUT_PERCENT_OPTIONS = Object.freeze({
  max: 100,
  min: 0,
  suffix: '%',
})

export const CREDIT_SUBSCRIPTION_INPUT_FIX_PRICE_OPTIONS = Object.freeze({
  max: 100000,
  min: 0,
  suffix: 'Ft',
})

export const MONTHLY_SUBSCRIPTION_INPUT_INFINITE_CONSUMPTION_OPTIONS = Object.freeze({
  label: 'Jogdíj óra után',
  max: 100000,
  min: 0,
  suffix: 'Ft',
})

export const MONTHLY_SUBSCRIPTION_INPUT_FIX_PRICE_AFTER_CONSUMED_PERCENT_OPTIONS = Object.freeze({
  label: 'Fix jogdíj % hallgatás után',
  max: 100000,
  min: 0,
  suffix: 'Ft',
})

export const INFLUENCER_SETUP_TYPE = Object.freeze({
  ACTIVATE_BOOKS: 'ACTIVATE_BOOKS',
  SELECT_ANY_BOOK: 'SELECT_ANY_BOOK',
  SELECT_ONE_BOOK: 'SELECT_ONE_BOOK',
  SUBSCRIPTION_DISCOUNT: 'SUBSCRIPTION_DISCOUNT',
})

export const INFLUENCER_SETUP_TYPE_OPTIONS = Object.freeze({
  [INFLUENCER_SETUP_TYPE.ACTIVATE_BOOKS]: {
    label: 'Könyvek aktiválása, ajándékkód'
  },
  [INFLUENCER_SETUP_TYPE.SELECT_ANY_BOOK]: {
    label: 'Influencer, 1 könyvet választhat'
  },
  [INFLUENCER_SETUP_TYPE.SELECT_ONE_BOOK]: {
    label: 'Influencer, listából 1 könyvet választhat'
  },
  [INFLUENCER_SETUP_TYPE.SUBSCRIPTION_DISCOUNT]: {
    label: 'Influencer, egyedi előfizetés'
  },
})

export const INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE = Object.freeze({
  NO_INFLUENCER_SUBSCRIPTION_IN_LAST: 'NO_INFLUENCER_SUBSCRIPTION_IN_LAST',
  NO_SUBSCRIPTION_IN_LAST: 'NO_SUBSCRIPTION_IN_LAST',
  NO_MATTER: 'NO_MATTER',
  MUST_HAVE_REDEEMED_COUPON: 'MUST_HAVE_REDEEMED_COUPON',
})

export const INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE_OPTIONS = Object.freeze({
  [INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE.NO_INFLUENCER_SUBSCRIPTION_IN_LAST]: {
    label: 'Nem volt influencer kuponos előfizetése az elmúlt ...'
  },
  [INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE.NO_SUBSCRIPTION_IN_LAST]: {
    label: 'Nem volt előfizetése az elmúlt ...'
  },
  [INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE.NO_MATTER]: {
    label: 'Nem számít, hogy volt e bármilyen előfizetése'
  },
  [INFLUENCER_SETUP_EARLIER_SUBSCRIPTION_CONDITION_TYPE.MUST_HAVE_REDEEMED_COUPON]: {
    label: 'Korábban beváltott egy adott kuponkódot'
  },
})


export const FICTIONALITY_OPTIONS = Object.freeze([
  { value: '', name: '—' },
  { value: 'FICTION', name: 'Fikció' },
  { value: 'NON_FICTION', name: 'Nem fikció' },
]);

export const AUDIENCE_OPTIONS = Object.freeze([
  { value: '', name: '—' },
  { value: 'CHILD', name: 'Gyerekeknek' },
  { value: 'NOT_CHILD', name: 'Nem gyerekeknek' },
  { value: 'ADULT_ONLY', name: 'Csak felnőtt (18+)' },
]);

export const ROYALTY_ACCOUNTING_MODE = Object.freeze({
  AGGREGATED: 'AGGREGATED',
  BOOK_ACTIVATION_ORDER: 'BOOK_ACTIVATION_ORDER',
  PER_BOOK: 'PER_BOOK',
});

export const USER_ROLE = {
  USER: 'USER',
  INFLUENCER: 'INFLUENCER',
  PARTNER: 'PARTNER',
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
};

export const ADMIN_ROLES = [USER_ROLE.ADMIN, USER_ROLE.SUPERADMIN];

export const PARTNER_ROLES = [USER_ROLE.OWNER, USER_ROLE.INFLUENCER];

export const PORTAL_ROLES = [...ADMIN_ROLES, ...PARTNER_ROLES];

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  DELETE_REQUESTED: 'DELETE_REQUESTED',
  INACTIVE: 'INACTIVE',
};

export const USER_STATUS_DROPDOWN_VALUES = Object.freeze([
  { value: USER_STATUS.ACTIVE, name: 'Aktív' },
  { value: USER_STATUS.DELETED, name: 'Törölt' },
  { value: USER_STATUS.DELETE_REQUESTED, name: 'Törlés kérelmezve' },
  { value: USER_STATUS.INACTIVE, name: 'Inaktív' },
])


export const SEX = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const STATUS_OPTIONS = Object.freeze({
  [STATUS.ACTIVE]: {
    label: 'Aktív',
  },
  [STATUS.INACTIVE]: {
    label: 'Inaktív',
  },
})

export const SORTING = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const OPERATOR = {
  GTE: 'GTE',
  LTE: 'LTE',
};

export const SUBSCRIPTION_TYPE = {
  MONTHLY: 'MONTHLY',
  CREDIT: 'CREDIT',
  FIX: 'FIX',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELED: 'CANCELED',
  PAST_DUE: 'PAST_DUE',
};

export const RENEW_SUBSCRIPTION_RESULT = Object.freeze({
  RENEWAL_STARTED: 'RENEWAL_STARTED',
  SUBSCRIPTION_NOT_ACTIVE: 'SUBSCRIPTION_NOT_ACTIVE',
  SUBSCRIPTION_NOT_RECURRING: 'SUBSCRIPTION_NOT_RECURRING',
});

export const SUBSCRIPTION_DURATION = {
  ONE_MONTH: 'ONE_MONTH',
  FOUR_MONTHS_PLUS_ONE: 'FOUR_MONTHS_PLUS_ONE',
  SIX_MONTHS: 'SIX_MONTHS',
  TWELVE_MONTHS: 'TWELVE_MONTHS',
  TWELVE_MONTHS_PLUS_FIVE: 'TWELVE_MONTHS_PLUS_FIVE',
  TWENTY_MONTHS: 'TWENTY_MONTHS',
  INFINITIVE: 'INFINITIVE',
};

export const RIGHTOWNER_TYPE = {
  AUDIO: 'AUDIO',
  TRANSLATION: 'TRANSLATION',
};

export const REGEX = {
  PASSWORD_REGEX: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/i,
  EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
};

export const EPISODE_STEPS = {
  UPLOAD: 'UPLOAD',
  DATA: 'DATA',
  FINISH: 'FINISH',
};

export const CANCELATION_TYPE = {
  BY_USER: 'BY_USER',
  BY_PAST_DUE: 'BY_PAST_DUE',
  BY_STORNO: 'BY_STORNO',
  NONE: 'NONE',
};

export const BOOK_TYPES = {
  EBOOK: 'EBOOK',
  SHORT: 'SHORT',
  FULL: 'FULL',
  PODCAST: 'PODCAST',
  MEDITATION: 'MEDITATION',
  STANDUP: 'STANDUP',
};

export const BOOK_TYPES_DROPDOWN_VALUES = Object.freeze([
  { value: BOOK_TYPES.SHORT, name: 'Könyvösszefoglaló' },
  { value: BOOK_TYPES.FULL, name: 'Hangoskönyv' },
  { value: BOOK_TYPES.PODCAST, name: 'Podcast' },
  { value: BOOK_TYPES.EBOOK, name: 'E-könyv' },
  { value: BOOK_TYPES.MEDITATION, name: 'Meditáció' },
  { value: BOOK_TYPES.STANDUP, name: 'Standup' },
])

export const CONTENT_TYPES = BOOK_TYPES;

export const CATEGORY_GROUPS = Object.freeze({
  KNOWLEDGE: 'KNOWLEDGE',
  STORIES: 'STORIES',
  KIDS: 'KIDS',
});

export const CATEGORY_GROUP_DROPDOWN_VALUES = Object.freeze([
  { value: CATEGORY_GROUPS.KNOWLEDGE, name: 'Tudás' },
  { value: CATEGORY_GROUPS.STORIES, name: 'Történetek' },
  { value: CATEGORY_GROUPS.KIDS, name: 'Gyerek' },
]);

export const ALL_CATEGORY_GROUPS = Object.freeze(CATEGORY_GROUP_DROPDOWN_VALUES.map(({ value }) => value));

export const YOUTUBE_PROCESS_STATUS = {
  NON_UPLOADED: 'NON_UPLOADED',
  UPLOADING_STARTED: 'UPLOADING_STARTED',
  UPLOADING_ERRORED: 'UPLOADING_ERRORED',
  UPLOADED: 'UPLOADED',
};

export const USER_COUPON_TYPE = {
  NORMAL: 'NORMAL',
  CREATED_BY_LINK: 'CREATED_BY_LINK',
};

export const REFUND_TRANSACTION_STATUS = Object.freeze({
  INITED: 'INITED',
  SUCCESS: 'SUCCESS',
})

export const PLEASE_SELECT_DROPDOWN_VALUE = Object.freeze({
  value: '-',
  name: 'Kérem válasszon!',
})

export const TIME_UNIT = Object.freeze({
  MINUTES: 'MINUTES',
  HOURS: 'HOURS',
  DAYS: 'DAYS',
  WEEKS: 'WEEKS',
  MONTHS: 'MONTHS',
  YEARS: 'YEARS',
})

export const TIME_UNIT_OPTIONS = Object.freeze({
  [TIME_UNIT.MINUTES]: {
    label: 'Perc',
  },
  [TIME_UNIT.HOURS]: {
    label: 'Óra',
  },
  [TIME_UNIT.DAYS]: {
    label: 'Nap',
  },
  [TIME_UNIT.WEEKS]: {
    label: 'Hét',
  },
  [TIME_UNIT.MONTHS]: {
    label: 'Hónap',
  },
  [TIME_UNIT.YEARS]: {
    label: 'Év',
  },
})

export const VAT_MULTIPLIER = 1.27;

export const PURCHASED_GIFT_STATUS = {
  ACTIVE: 'ACTIVE',
  INITED: 'INITED',
  FALIED: 'FALIED',
  USED: 'USED',
  DELETED: 'DELETED',
};

export const AFFILATE_BOOK_PURCHASE_TYPE = {
  ROYALTIES_INCLUDED: 'ROYALTIES_INCLUDED',
  ROYALTY_FREE: 'ROYALTY_FREE',
  ROYALTIES_INCLUDED_ON_WAIT: 'ROYALTIES_INCLUDED_ON_WAIT',
};
